"use client";

import * as React from "react";
import { useWalletInfoContext } from "../providers/wallet-info-provider";

export interface WalletInfoNavProps {
  position?: "top" | "bottom";
  children: React.ReactNode;
}

export function WalletInfoNav({
  position = "top",
  children,
}: WalletInfoNavProps) {
  const { setNavContent, setNavPosition } = useWalletInfoContext();

  React.useEffect(() => {
    setNavContent(children);
    setNavPosition(position);
    return () => setNavContent(null);
  }, [children, position, setNavContent, setNavPosition]);

  return null;
}
